import { CHATBOT_NAME } from '../config/appConstants';
import { Citation, Message } from "../models/models";

export const formatMessageForMarkdown = (text: string): string => {
    return text
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n')
        .replace(/\n\n+/g, '\n\n')
        .replace(/([^\n])\n([^\n])/g, '$1  \n$2');
};

export const extractCitations = (text: string): { cleanText: string; citations: Citation[] } => {

    let cleanText = text;
    const allCitations: Citation[] = [];

    const citationRegex = /CITATIONS:\s*(\[[^\]]*(?:\][^\]]*)*\])/g;
    let match;

    while ((match = citationRegex.exec(text)) !== null) {

        try {
            const citations = JSON.parse(match[1]);
            if (Array.isArray(citations)) {
                allCitations.push(...citations);
            }
        } catch (e) {
            console.error(e)
        }
    }

    cleanText = text.replace(/CITATIONS:\s*\[[^\]]*(?:\][^\]]*)*\]/g, '').trim();

    return { cleanText, citations: allCitations };
};

export const mapServerMessageToClientMessage = (msg: any): Message => {
    const { cleanText, citations } = extractCitations(msg.content);

    return {
        author: msg.author === 'ASSISTANT' ? CHATBOT_NAME : msg.author,
        text: formatMessageForMarkdown(cleanText),
        isSystem: msg.author === 'ASSISTANT',
        isLoading: false,
        documents: msg?.messageDocumentInfoResponses || undefined,
        timestamp: msg.timestamp,
        citations: citations.length > 0 ? citations : undefined
    };
};

export const mapCollectionsToDataSourceIds = (conversationDataSources: any, conversationCollections: any): number[] => {
    const collections = ((conversationDataSources ?? conversationCollections) ?? [])
        .map((c: any) => ({...c, owner: {email: c?.owner?.email}}));
    return collections.map((c: any) => c.id);
};

export const createDefaultUserMessage = (author: string, text: string, attachedFiles: File[]): Message => {
    return {
        author,
        text,
        isSystem: false,
        documents: attachedFiles.length > 0
            ? attachedFiles.map(file => ({
                documentId: -1,
                documentName: file.name
            }))
            : undefined,
        timestamp: new Date().toISOString()
    };
};

export const createDefaultLoadingMessage = (): Message => {
    return {author: CHATBOT_NAME, text: '', isSystem: true, isLoading: true};
};
